import { AudioContext } from './AudioProvider';
import { AudioContextShape } from './models/AudioContextShape';
import pauseIcon from './images/pause.svg';
import playIcon from './images/play.svg';
import PlayingTracker from './PlayingTracker';
import style from './styles/App.module.scss';
import { useContext } from 'react';
import { useSize } from './hooks/useSize';
import { isMediumStyle, isSmallStyle, progressEndpoint } from './functions';

const FIFTY_PERCENT = 0.5;

// TODO: alt intl, button title

export default function PlayButton() {
    const audio = useContext<AudioContextShape>(AudioContext);
    const sizeStyle = useSize();
    
    let progress = audio.state.currentTime / audio.state.duration;
    if (isNaN(progress)) progress = 0;
    const largeArcFlag: (0|1) = progress > FIFTY_PERCENT ? 1 : 0;
    const { x1, y1 }: { x1: number, y1: number } = progressEndpoint(progress);
    let playClasses = style.play;
    if (isMediumStyle(sizeStyle) || isSmallStyle(sizeStyle)) {
        playClasses += ' ' + sizeStyle.play;
    }
    
    if (!audio?.state || audio.state.paused) {
        return <button className={playClasses} onClick={() => audio.state.play()}>
            <img src={playIcon} alt={'Play'} />
            <PlayingTracker largeArcFlag={largeArcFlag} x={x1} y={y1} />
        </button>;
    }
    return <button className={playClasses} onClick={() => audio.state.pause()}>
        <img src={pauseIcon} alt={'Pause'} />
        <PlayingTracker largeArcFlag={largeArcFlag} x={x1} y={y1} />
    </button>;
}